module.exports = {
    loading:'လုပ်ဆောင်နေသည်',
    logout:'ထွက်မည်',
    logoutDesc:'အကောင့်မှထွက်ရန်သေချာပြီလား',
    check:'စစ်ဆေးသည်',
    asntitle:'ဖြေဆိုချိန်',
    asntitle2:'မေးခွန်းလက်ကျန်',
    Correct:'မှန်ပါသည်',
    wrong:' မှားပါသည်',
    ansTitle1:'အရမ်းတော်တယ်',
    ansTitle2:' မင်းမှန်နေတုန်းပဲ',
    ansTitle22:'အဖြေမမှန်ပါဘူး',
    ansTitle3:'ကပ်လွဲသွားတာပဲ!',
    congratulations:'ဂုဏ်ယူပါတယ်',
    otp:'တစ်ခါသုံးစကားဝှက်',
    ladingpageTips:'(ဇန်နဝါရီ ၉ ရက်မှ ဖေဖော်ဝါရီ ၇ ရက်အထိ အခမဲ့)',
    ladingpageTips2:'စတင်အသုံးပြုသူအသစ်များအတွက်သာ',
    Daily:'နေ့စဥ်',
    dailyM:'၁၇၉ ကျပ်',
    Weekly:'အပတ်စဥ်',
    weeklyM:'၇၉၉ ကျပ်',
    Monthly:'လစဥ်',
    monthlyM: '၃၉၉၉ ကျပ်',
    subscribeNow:'စာရင်းသွင်းမည်',
    Copyright:'မူပိုင်ခွင့် © Grab&Get 2025',
    CopySucceeded:'ကူးယူမှုအောင်မြင်ပါသည်',
    play:'ရွေးချယ်ပါ',
    myAccount:' ကိုယ်ရေးအချက်လက်များ',
    profile:'မိမိအကောင့်',
    FAQs:'သိလိုရာများ',
    TC:'စည်းကမ်းချက်များ',
    language:'ဘာသာစကား',
    PickLanguage:'ဘာသာစကားရွေးချယ်ပါ',
    Submit:'အတည်ပြုမည်',
    change:'ပြောင်းလဲမည်',
    English:'အင်္ဂလိပ်',
    showMore:'ထပ်မံကြည့်ရှုမည်',
    Login:'အကောင့်ဝင်မည်',
    Logout:'အကောင့်မှထွက်မည်',
    getCode:'ပြန်ပို့မည်',
    phoneNumber:'ဖုန်းနံပါတ်',
    enderNumber:'ဖုန်းနံပါတ်ဖြည့်သွင်းပါ',
    Name:'အမည်',
    address:'လိပ်စာ',
    phone:'ဖုန်းနံပါတ်',
    Prize:'ဆုများ',
    referral:'ဖိတ်ခေါ်မည်',
    winnerList:'ကံထူးသူစာရင်း',
    Date:'နေ့စွဲ',
    Save:'သိမ်းမည်',
    cancel:'ပယ်ဖျက်ရန်',
    Confirm:'အတည်ပြုမည်',
    goBack:'နောက်သို့',
    No:'ငြင်းပယ်မည်',
    OK:'လက်ခံမည်',
    Yes:'အိုကေ',
    UNSUBSCRIBE:'ထွက်မည်',
    noMore:'မရှိတော့ပါ',
    more:'ထပ်မံ',
    ohNo:'အိုးနိုး',
    subDes2:'သင်ပယ်ဖျက်မည်ကို စိတ်မကောင်းပါ',
    des2:'ပယ်ဖျက်မှာသေချာပြီလား' ,
    boxes:' ကဒ်အရေအတွက်',
    box:'စုစု‌ပေါင်းကဒ်',
    memberGetMember:'အဖွဲ့ ဝင်ဖိတ်ခေါ် မည်',
    referralTips2:'သင်ရဲ့ ဖတ်ခေါ်ရန်လင့်ခ်',
    referralTips3:'သင့်သူငယ်ခြင်း၏ဖိတ်ခေါ်ရန်လင့်ခ်',
    Status:'အဆင့်',
    noFound:'ရလဒ်များမတွေ့ရပါ',
    cgtips1:'ဆုမဲကြီးများကံထူးပါ',
    cgtips2:'၁၄၉ကျပ်/နေ့စဥ်,<br />စာရင်းသွင်းရန် အိုကေ ကိုနှိပ်ပါ',
    cgtips2W:'၅၉၉ကျပ်/weekly,<br />စာရင်းသွင်းရန် အိုကေ ကိုနှိပ်ပါ',
    indexbutton1:'ကစားမည်။',
    getMorecards:'အမှတ်များများရရှိရန်',
    indexbutton2:'၉ ကြိမ်ရွေးချယ်ရန်',
    landFont1:'ဖုန်းနံပါတ်',
    landFont2:'ပက်ကေ့ခ်ျ ရွေးချယ်ပါ',
    landingFont:'စာရင်းသွင်းခြင်းအတွက် ပင်မလက်ကျန်မှ ကောက်ခံပါမည်။',
    optTips:'စာရင်းသွင်းပြီးသားဖြစ်ပါသည်, အကောင့်သို့ဝင်ရန် အိုကေ ကိုနှိပ်ပါ',
    landingContent:'<div class="ac">Mytel သက်မှတ်ထားသော စည်းမျဉ်းများ</div><br />1.သင်ရွေးချယ်ထားသော ဝန်ဆောင်မှုအပေါ် အခြေခံ၍ နေ့စဉ်/ အပတ်စဉ်/ လစဉ် အရစ်ကျ အခကြေးငွေဖြင့် ဝန်ဆောင်မှုကို 365 ရက်အထိ အသုံးပြုနိုင်မည်ဖြစ်သည်။<br /><br />2.Mytel သည် အချိန်အတိုင်းအတာတစ်ခုအထိ ဝန်ဆောင်မှုအသုံးပြုမှုအကြိမ်ရေများအတွက် အခကြေးငွေများ (ဥပမာ၊ သက်တမ်းတိုးခြင်းမရှိသော သို့မဟုတ် နေ့စဉ်၊ အခကြေးငွေမရှိ) သို့မဟုတ် အရစ်ကျငွေပေးချေမှုနည်းလမ်း (ဥပမာ- ဝန်ဆောင်မှု၏ 365 ရက်အပေါ်အခြေခံ၍ နေ့စဥ်/အပတ်စဉ် ကောက်ခံမှုဖြစ်နိုင်သည်)<br /><br />3။ Mytel ၏ ပါတနာ (တတိယပါတီ) သည် ၎င်းတို့၏ ဝန်ဆောင်မှုအတွက် အစမ်းကာလကို ပံ့ပိုးပေးမည်ဆိုပါက၊ သုံးစွဲသူသည် အစမ်းသုံးကာလ ကုန်ဆုံးသည့်နေ့အထိ ခံစားနိုင်သည်။ထို့နောက် အစမ်းသုံးကာလ ကုန်ဆုံးပြီးနောက်တွင် သင်ရွေးချယ်ထားသော ဝန်ဆောင်မှုအပေါ် အခြေခံ၍ ကျွန်ုပ်တို့ ကောက်ခံပါမည်။အစမ်းသုံးကာလကုန်ဆုံးပြီးနောက် နေ့စဉ်/ အပတ်စဉ် ဝန်ဆောင်မှုများအတွက် သင့်မိုဘိုင်းလက်ကျန်ငွေမှ ကောက်ခံရရှိမည်ဖြစ်သည်။ဤဝန်ဆောင်မှုစည်းမျဥ်းအခကြေးငွေများကြောင့် ဝန်ဆောင်မှုကို ဝင်ရောက်အသုံးပြုခွင့် အသိအမှတ်ပြုခြင်းနှင့် လက်ခံအတည်ပြုခြင်းအတွက် လျှောက်ထားပါ။<br /><br />4။ စာရင်းသွင်းမှုကို နှိပ်ခြင်းဖြင့် သင်သည် အသုံးပြုထားသော ဝန်ဆောင်မှု၏ စည်းမျဥ်းစည်းကမ်းများကို လက်ခံပါသည်။',
  Invitation_Link:'သင်၏ဖိတ်ခေါ်မှုလင့်ခ်',
  Copy:'ကူးယူပါ',
  Invitation_Count:'ဖိတ်ခေါ် မှုအကြိမ်ရေ',
  homeTotal1:'ကစားခွင့်အကြိမ်ရေ',
  homefont2:'ဆုကြီးများရယူရန် ကဒ်များကိုလှန်ပါ',
  buyPack:'ကစားခွင့်ဝယ်ယူရန်',
  buyNow:'အခုဝယ်ယူမည်',
  buyContent:'ဂိမ်းကစားခွင့် ၁ခု ပိုမိုဝယ်ယူလေလေ အမှတ်များများပိုရလေလေဖြစ်သည်',
  luckyTips1:'ကဒ်တစ်ခုစီတိုင်းတွင် အောက်ပါဆုများကို ဆွတ်ခူးရန် အခွင့်အရေးရှိသည်။.',
  alertTips:'သင်သည် သူငယ်ချင်းများကို အောင်မြင်စွာ ဖိတ်ကြားထားပါသည်',
  personalInfo:'ကိုယ်‌ရေးအချက်လက်များ',
  invitation_log:'ဖိတ်ခေါ်မှုမှတ်တမ်း',
  ruleTask:'ဂိမ်းစည်းမျဥ်းများ',
  DailyLogin:'နေ့စဥ်ဝင်ယူရန်',
  DailyLoginT1:'စိတ်လှုပ်ရှားဖွယ်ရာဆုလာဘ်များကို ဖွင့်ရန် နေ့စဉ်ဝင်ရောက်ပါ။ သင်ဝင်ရောက်လေလေ၊ ဆုများရလေဖြစ်ပါတယ်။',
  Claim:'ရယူပြီး',
  Missed:'လွတ်သွားသည်',
  ReClaim:'ပြန်လည်ရယူပါ ',
  DailyLoginT2:'လွဲချော်သွားသောဆုကိုပြန်လည်ရယူပါ။',
  DailyLoginT3:'လွဲချော်သွားသောဆုကို ၁၂၉ကျပ် ဖြင့်ပြန်လည်ရယူပါ။',
  yesClaim:'ရယူမည်',
  "indexbutton12": "အကန့်အသတ်မရှိ အသုံးပြုနိုင်သည်!",
  "game_list": "မီနီဂိမ်းများကို ရွေးပါ",
  "Play": "ကစားမည်",
  "Easy": "လွယ်ကူသည်",
  "Medium": "အလယ်အလတ်",
  "Hard": "ခက်ခဲသည်",
  "Level": "အဆင့်",
  // "ChooseTips1": "အဆင့် ၁၊ ၂ သို့မဟုတ် ၃ ကို ရွေးပါ။<br />အဆင့်မြင့်ပါက အနိုင်ရရှိမှုပိုများနိုင်သည်",
  "ChooseTips1": "ကံအဆင့်(၁)၊(၂) သို့မဟုတ် (၃)<br /> ကိုရွေးပါ။ကံအဆင့်မြင့်ပါက ဆုကြီးများပိုရနိုင်သည်။",
  "total_starts": "စုစုပေါင်းအမှတ်",
  "Stars": "ရမှတ်",
  "Ranking": "အဆင့်များ",
  "Packs": "ပက်ကေ့ချ်များ",
  "pkfont1": "တစ်ကြိမ်သုံးပက်ကေ့ချ်",
  "pkfont2": "ကစားခွင့်ဝယ်မည်",
  "pkfont3": "ဂိမ်းကစားခွင့် ၁ ကြိမ်ထပ်ဝယ်မည်",
  "pkfont4": "၁၂၉ ကျပ်",
  "pkfont21": "ဗီအိုင်ပီ ပက်ကေ့ချ်",
  "pkfont22": "၃၀ ရက်အတွက်",
  "pkfont23": "နေ့စဉ် ဂိမ်းကစားခွင့် ၅ ကြိမ်၊ အမှတ် ၂၀၀၊ ဗီအိုင်ပီ လိုဂိုနှင့်ဘောင်",
  "pkfont24": "၃၉၉၉ ကျပ်",
  "pkfont31": "အပတ်စဉ်ပက်ကေ့ချ်များ",
  "pkfont32": "တစ်ပတ်အတွက်",
  "pkfont33": "ဂိမ်းကစားခွင့် ၁၀ ကြိမ်",
  "pkfont34": "၇၉၉ ကျပ်",
  "pkfont41": "နေ့စဉ်ပက်ကေ့ချ်များ",
  "pkfont42": "နေ့စဉ်ဝန်ဆောင်မှု",
  "pkfont43": "နေ့စဉ် ဂိမ်းကစားခွင့် ၁ ကြိမ်",
  "pkfont44": "၁၉၉ ကျပ်",
  "Yearly": "တနှစ်ပတ်လုံး",
  "Invitation successful!": "ဖိတ်ခေါ်မှုအောင်မြင်ပါသည်!",
  "invitTips1": "ကစားသမားအသစ်ကိုဖိတ်ခေါ်ခြင်းကြောင့် 'အမှတ် ၁၀၀၀' ရရှိပါသည်!",
  "Card Name": "ကဒ်အမည်",
  "Thank You": "ကျေးဇူးတင်ပါတယ်",
  "no prize found": "ဆုမရရှိပါ",
  "Better luck next time!": "နောက်တစ်ကြိမ်မှာကံကောင်းပါစေ!",
  "LvL_1": "ကံအဆင့်(၁)",
  "LvL_2": "ကံအဆင့်(၂)",
  "LvL_3": "ကံအဆင့်(၃)",
  "level_tip1": "အမှတ် ၁၀၀ ဖြင့် ကံအဆင့်(၁) ရှိကဒ်များကို လှန်၍ ဆုကြီးများကံထူးနိုင်ပါသည်။",
  "level_tip2": "အမှတ် ၂၀၀ ဖြင့် ကံအဆင့်(၂) ရှိကဒ်များကို လှန်၍ ဆုကြီးများကံထူးနိုင်ပါသည်။",
  "level_tip3": "အမှတ် ၃၀၀ ဖြင့် ကံအဆင့်(၃) ရှိကဒ်များကို လှန်၍ ဆုကြီးများကံထူးနိုင်ပါသည်။",
  "indexbutton3": "ကစားခွင့်ဝယ်ယူရန်",
  loginTips:"ဖုန်းနံပါတ်ထည့်ပါ",
  upload_fail:"ပုံတင်ခြင်း မအောင်မြင်ပါ",
  home_prize_tip:"ဂိမ်းကစားပြီး ဆုကြီးများကိုကံစမ်းလိုက်ပါ!",
  buy_popup_tip1:"အကြိမ်ရေ ဝယ်ယူမည်",
  buy_popup_tip2:"129 ကျပ်ဖြင့်အခွင့်လမ်းများရယူပါ။ဂိမ်းကစားခွင့်များဝယ်ယူရန် 'ဝယ်ယူမည်' ကိုနှိပ်ပါ။",
  Guidance:'လမ်းညွှန်ချက်',
  Subscribe:'စာရင်းသွင်းပါ',
  DailyKyats:'149 Kyats',
  WeeklyKyats:'599 Kyats',
  OneTime:'တစ်ကြိမ်',
  Purchase:'ဝယ်ယူမည်',
  OneTimeChance:'၁၂၉ ကျပ်',
  lucky_draw:'ကံစမ်းမဲ',
  yearly_list:'နှစ်စဉ်စာရင်း',
  month_list:'လစဉ်စာရင်း',
  week_list:'အပတ်စဉ်စာရင်း',
  daily_tip: "အကျိုးအမြတ်: ကစားခွင့် ( ၂ ) ခု",
  weekly_tip: 'အကျိုးအမြတ်: <br />ပထမနေ့တွင် ကစားခွင့် (၄)ခုရရှိမည်။ <br />နောက်ရက်များအတွက် တစ်နေ့ကို ကစားခွင့် (၁)ခုစီရရှိမည်။<br />စုစုပေါင်း: ကစားခွင့် (၁၀)ခု',
  monthly_tip: 'အကျိုးအမြတ်: <br />နေ့စဥ်ကစားခွင့် (၅)ခု<br />အမှတ် (၂၀၀)<br />VIP Royal လိုဂို<br />VIP စပယ်ရှယ် ပရိုဖိုင်ဘောင် (ရက် ၃၀ သက်တမ်း)',
  buy_tip:"အကျိုးအမြတ်: ကစားခွင့် (၁)ခု",
  daily_pack:"နေ့စဉ်ပက်ကေ့ဂျ်",
  weekly_pack:"အပတ်စဉ်ပက်ကေ့ဂျ်",
  monthly_pack:"လစဉ်ပက်ကေ့ဂျ်",
  one_time_package:"အပိုဆောင်းပက်ကေ့ဂျ်",
  sub_tip:'အလွယ်တကူ စာရင်းသွင်းဖို့<br />*615# ကိုခေါ်ဆိုပါ သို့မဟုတ် 615 သို့ HELP ဟုSMS ပေးပို့ပါ။<br />အစီအစဥ်ပယ်ဖျက်ရန် 615 သို့ OFF ပို့ပါ။<br />',
  GrabGet:'Grab & Get',
  "Free Time": "အခမဲ့အချိန်",
  "chance": "ကစားခွင့်",
  'goGet':'ယူလိုက်ပါ',
  'join_us':'*615# ကိုခေါ်ဆို၍လည်း ဝန်ဆောင်မှုအား ရယူနိုင်ပါသည်',
  'avatar':'ရုပ်ပုံ',
  sharePanelTitle:'သူငယ်ချင်းများထံ မျှဝေပါ',
  sharePanelTips:'အောက်ပါ platform များထဲမှ တစ်ခုကိုရွေးပြီး invite link ကို တိုက်ရိုက်ပို့လိုက်ပါ။',
  shareMore:'အခြား App များသို့ မျှဝေမယ်',
  referralTips1:"ဆုလက်ဆောင်များရယူရန် အသုံးပြုသူအသစ်ကို ဖိတ်ခေါ်ပါ။ အမှတ် ၁၀၀၀ ကို ဖိတ်ကြားသူနဲ့ ဖိတ်ကြားခြင်းခံရသူ နှစ်ဦးစလုံးရရှိပါမည်။",

}



// WEBPACK FOOTER //
// ./src/assets/i18n/bur.js